module.exports = __webpack_public_path__ + "img/wap_slides_bg_05.86f9223e.png";